import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { ChatDemo } from './ChatDemo';
export function HeroSection() {
  return <section className="relative bg-slate-50 pt-16 pb-24 lg:pt-24 lg:pb-32 overflow-hidden" data-id="element-87">
      {/* Background decorative elements */}
      <div className="absolute inset-y-0 left-0 w-1/2 bg-white rounded-r-3xl shadow-[0_0_40px_rgba(0,0,0,0.02)] hidden lg:block" data-id="element-88"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-center" data-id="element-90">
          {/* Text Content */}
          <div className="lg:col-span-5 mb-12 lg:mb-0 text-center lg:text-left" data-id="element-91">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-sm font-medium mb-6" data-id="element-92">
              <ShieldCheckIcon className="w-4 h-4 mr-2" data-id="element-93" />
              1,247 restaurants monitored · Updated daily
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight mb-6" data-id="element-94">
              Know Before <br className="hidden lg:block" data-id="element-95" />
              <span className="text-emerald-600" data-id="element-96">You Go.</span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-600 leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-97">
              Ask our AI assistant anything about restaurant health inspections
              in Franklin County. Get instant answers, context on violations,
              and peace of mind—not spreadsheets.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-98">
              <button className="px-6 py-3 rounded-lg bg-slate-900 text-white font-medium hover:bg-slate-800 transition-colors shadow-sm" data-id="element-99">
                Ask About a Restaurant
              </button>
            </div>
          </div>

          {/* Chat Demo Container */}
          <div className="lg:col-span-7 relative z-10" data-id="element-100">
            <div className="absolute -inset-4 bg-emerald-500/10 blur-3xl rounded-full opacity-50" data-id="element-101"></div>
            <ChatDemo data-id="element-102" />
          </div>
        </div>
      </div>
    </section>;
}